

























































































import { SimpleAvailabilitySearchResult } from '@/shared/models/availability';
import { ListModel } from '@/shared/models/listModel';
import { Component, Prop, PropSync, Vue, Watch } from 'vue-property-decorator';
import NoData from "@/components/misc/NoData.vue";
import { Getter } from 'vuex-class';
import { GlobalFilterProperty } from '@/store/modules/globalFilters';

@Component({ components: { NoData }})
export default class SimpleAvailabilitySearchModal extends Vue {
  @PropSync('open') internalOpen?: boolean;
  @Prop() availabilityFilter?: any;
  @Prop() selectedUnitIds?: number[];
  @Prop({ default: () => [] }) ownerIds?: number[];

  @Getter("globalFilters/filteredProperties") properties?: GlobalFilterProperty[];

  @Watch('$route') 
  routeChanged() {
    this.internalOpen = false;
  }

  @Watch('internalOpen') 
  onOpenChanged(fresh: boolean) {

    if (fresh) {
        this.selectedPropertyNameValue = this.availabilityFilter.propertyName != ""
            ? this.availabilityFilter.propertyName
            : this.properties?.find((x, index) => index == 0)?.name ?? "";
        this.loadUnits();
    } else {
        this.units = [];
        this.selected = [];
        this.accommodationUnitNameFilter = "";
        this.accommodationUnitTypeNameFilter = "";
    }
  }

  selectedPropertyNameValue = "";

  get selectedPropertyName(){
    return this.selectedPropertyNameValue;
  }
  //changing property should remove any previous selected unit
  set selectedPropertyName(val: string){
    if (val != this.selectedPropertyNameValue){
      this.selectedPropertyNameValue = val;
      this.selected = [];
    }
  }

  loadingUnits = true;
  units: SimpleAvailabilitySearchResult[] = [];
  loadUnits() {
    this.loadingUnits = true;
    Vue.axios
      .get<ListModel<SimpleAvailabilitySearchResult>>(
        "/advancedSearch/FindAvailableAccUnitsForProperty",
        {
          params: {
            $count: true,
            $skip: this.units.length,
            propertyName: this.selectedPropertyName,
            arrivalDate: this.availabilityFilter.arrivalDate,
            departureDate: this.availabilityFilter.departureDate,
            ignoreRestrictions: this.ignoreRestrictions
          },
        }
      )
      .then((res) => {
        this.units.push(...res.data.result);
        if (res.data.count && this.units.length < res.data.count) {
          this.loadUnits();
        }
      })
      .finally(() => (this.loadingUnits = false));
  }

  ignoreRestrictions = true;
  ignoreRestrictionsChanged()
  {
    this.loadUnits();
  }

  propertyChanged() {
    this.units = [];
    this.loadUnits();
  }

  headers = [
    {
      text: "Accomodation unit",
      value: "accommodationUnitName",
    },
    {
      text: "Accomodation unit type",
      value: "accommodationUnitTypeName",
    },
  ];

  get translatedHeaders() {
    return this.headers.map((x) => ({ ...x, text: this.$t(x.text) }));
  }

  selected = [] as SimpleAvailabilitySearchResult[];

  accommodationUnitNameFilter = "";
  accommodationUnitTypeNameFilter = "";

  get filteredUnits() {
    if (!this.units) {
      return [];
    }
    
    let units = this.units;
    if (this.ownerIds && this.ownerIds.length > 0){
      units = units.filter(x => x.ownerId && this.ownerIds?.includes(x.ownerId));
    }

    return units
      .filter(
        (e) =>
          !this.accommodationUnitNameFilter ||
          e.accommodationUnitName.toLowerCase().includes(this.accommodationUnitNameFilter.toLowerCase())
      )
      .filter(
        (e) =>
          !this.accommodationUnitTypeNameFilter ||
          e.accommodationUnitTypeName.toLowerCase().includes(this.accommodationUnitTypeNameFilter.toLowerCase())
      )
      .filter(
        (e) =>
          !this.selectedUnitIds?.includes(e.accommodationUnitId)
      )
  }

  areAllUnitsSelected() {
    return !this.filteredUnits?.some(
      (e) =>
        this.selected.findIndex((acc) => acc.accommodationUnitId == e.accommodationUnitId) == -1
    );
  }

  selectUnit({
    item,
    value,
  }: {
    item: SimpleAvailabilitySearchResult;
    value: boolean;
  }) {
    if (
      value &&
      !this.selected.some((x) => x.accommodationUnitId == item.accommodationUnitId)
    ) {
      this.selected.push(item);
    } else if (!value) {
      const index = this.selected.findIndex(
        (x) => x.accommodationUnitId == item.accommodationUnitId
      );
      if (index != -1) {
        this.selected.splice(index, 1);
      }
    }
  }

  selectAllUnits(value: boolean) {
    if (!this.filteredUnits) {
      return;
    }

    if (value) {
      for (const unit of this.filteredUnits) {
        if (!this.selected.some((x) => x.accommodationUnitId == unit.accommodationUnitId)) {
          this.selected.push(unit);
        }
      }
    } else {
      for (const unit of this.filteredUnits) {
        const index = this.selected.findIndex(
          (x) => x.accommodationUnitId == unit.accommodationUnitId
        );

        if (index != -1) {
          this.selected.splice(index, 1);
        }

        const selectedIndex = this.selected.findIndex(
          (x) => x.accommodationUnitId == unit.accommodationUnitId
        );
        if (selectedIndex != -1) {
          this.selected.splice(selectedIndex, 1);
        }
      }
    }
  }

  submit() {
    this.internalOpen = false;

    this.$emit("unitsSelected", this.selected);
  }
}
